import Keycloak from 'keycloak-js';
import {KeycloakWrapperService} from './keycloak-wrapper.service';
import {inject} from '@angular/core';

export function initializeKeycloakInstance(): Promise<any> {
    const keycloakWrapperService = inject(KeycloakWrapperService);
    const keycloak = inject(Keycloak);
    keycloakWrapperService.setInstance(keycloak);
    keycloakWrapperService.setKeycloakSignal();
    return Promise.all([
        keycloakWrapperService.updateToken,
        keycloakWrapperService.getKeycloakInstance().loadUserProfile
    ]);

}
